import { GatewayLocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/locations/models/outputs/gateway-location.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';

export interface LocationListActionsHeaderProps
  extends HeaderContext<GatewayLocationModel, unknown> {}

export const LocationListActionsHeader =
  (): // props: LocationListActionsHeaderProps,
  ReactNode => {
    // RENDER ////////////////////////////////////////////////////////////////////

    return null;
  };
